// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as AllocationFilterWrapper from "../../../../allocation-dashboard-home/allocation-filters/AllocationFilterWrapper.bs.js";
import * as AllocationCampaignFooterCmp from "../../reusable-components/AllocationCampaignFooterCmp.bs.js";

function toFixedDecimalPoint(value, decimalPoint) {
  return Caml_format.caml_float_of_string(value.toFixed(decimalPoint));
}

function getCreatorInfo(preview_data) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", {
                      className: "status"
                    }, "Status"), React.createElement("p", undefined, "-")), React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Created By"), React.createElement("p", undefined, preview_data.created_by)), React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Created On"), React.createElement("p", undefined, Timestamp$Catalyst.toString(preview_data.created_on, "DD/MM/YYYY"))));
}

function getTimingInfo(preview_data) {
  var data = preview_data.endTime;
  var tmp;
  if (data !== undefined) {
    var data$1 = Caml_option.valFromOption(data);
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "section-row"
            }, React.createElement("p", {
                  className: ""
                }, "End Date ", React.createElement("label", {
                      className: "unit"
                    }, "(DD/MM/YYYY)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(data$1, "DD/MM/YYYY"))), React.createElement("div", {
              className: "section-row"
            }, React.createElement("p", {
                  className: ""
                }, "End Time ", React.createElement("label", {
                      className: "unit"
                    }, "(HH:MM)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(data$1, "HH:mm"))));
  } else {
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "section-row"
            }, React.createElement("p", {
                  className: ""
                }, "End Date (DD/MM/YYYY)"), React.createElement("p", undefined, "-")), React.createElement("div", {
              className: "section-row"
            }, React.createElement("p", {
                  className: ""
                }, "End Time (HH:MM)"), React.createElement("p", undefined, "-")));
  }
  return React.createElement(React.Fragment, undefined, React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: "section-row"
                    }, React.createElement("p", {
                          className: ""
                        }, "Type"), React.createElement("p", undefined, "Mandatory")), React.createElement("div", {
                      className: "section-row"
                    }, React.createElement("p", {
                          className: ""
                        }, "Start Date ", React.createElement("label", {
                              className: "unit"
                            }, "(DD/MM/YYYY)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(preview_data.startTime, "DD/MM/YYYY"))), React.createElement("div", {
                      className: "section-row"
                    }, React.createElement("p", {
                          className: ""
                        }, "Start Time ", React.createElement("label", {
                              className: "unit"
                            }, "(HH:MM)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(preview_data.startTime, "HH:mm")))), tmp);
}

function getFilterWithDelta(preview_data, active_mandatory_campaign) {
  return [
          {
            TAG: /* AllocationRadius */0,
            filter_value: {
              left_value: preview_data.allocationRadiusAutomatic,
              right_value: preview_data.allocationRadiusManual
            },
            delta_value: {
              left_value: preview_data.allocationRadiusAutomatic - active_mandatory_campaign.filters.allocation_radius.auto,
              right_value: preview_data.allocationRadiusManual - active_mandatory_campaign.filters.allocation_radius.manual
            }
          },
          {
            TAG: /* DryRun */1,
            filter_value: {
              left_value: preview_data.thresholdDistance,
              right_value: preview_data.dryRunRatio
            },
            delta_value: {
              left_value: preview_data.thresholdDistance - active_mandatory_campaign.filters.dry_run.threshold,
              right_value: preview_data.dryRunRatio - active_mandatory_campaign.filters.dry_run.ratio
            }
          },
          {
            TAG: /* MaxDryRun */2,
            filter_value: {
              left_value: preview_data.maxDryRunAutomatic,
              right_value: preview_data.maxDryRunManual
            },
            delta_value: {
              left_value: preview_data.maxDryRunAutomatic - active_mandatory_campaign.filters.maps_distance.auto,
              right_value: preview_data.maxDryRunManual - active_mandatory_campaign.filters.maps_distance.manual
            }
          }
        ];
}

function PreviewMandatoryCampaignCmp(Props) {
  var preview_data = Props.preview_data;
  var active_mandatory_campaign = Props.active_mandatory_campaign;
  var setFormStage = Props.setFormStage;
  var submitCTA = Props.submitCTA;
  var match = React.useState(function () {
        
      });
  var updateFilterWithDeltaValue = match[1];
  var filters = match[0];
  React.useEffect((function () {
          Curry._1(updateFilterWithDeltaValue, (function (param) {
                  return getFilterWithDelta(preview_data, active_mandatory_campaign);
                }));
          
        }), []);
  console.log(preview_data, active_mandatory_campaign);
  return React.createElement("div", {
              className: "c-preview-mandatory-campaign"
            }, React.createElement("div", {
                  className: "section"
                }, getCreatorInfo(preview_data)), React.createElement("div", {
                  className: "section"
                }, getTimingInfo(preview_data)), React.createElement("div", {
                  className: "section ald-filter-section"
                }, filters !== undefined ? $$Array.map((function (filter) {
                          return React.createElement(AllocationFilterWrapper.make, {
                                      filter_data: filter,
                                      show_header: true
                                    });
                        }), filters) : null), React.createElement(AllocationCampaignFooterCmp.make, {
                  onLeftBtnClick: (function (param) {
                      return Curry._1(setFormStage, (function (param) {
                                    return /* Edit */0;
                                  }));
                    }),
                  leftBtnText: "Back",
                  onRightBtnClick: (function (param) {
                      return Curry._1(submitCTA, undefined);
                    }),
                  rightBtnText: "Submit"
                }));
}

var make = PreviewMandatoryCampaignCmp;

export {
  toFixedDecimalPoint ,
  getCreatorInfo ,
  getTimingInfo ,
  getFilterWithDelta ,
  make ,
  
}
/* react Not a pure module */
